export default __webpack_public_path__ + "static/media/layer6.73d0af77.png";